/* Shoebella – productpagina hoge conversie (sections/sb-product-hc.liquid)
   Teksten komen vertaald uit [data-hc-config] (snippets/sb-hc-t.liquid).
   Uitverkochte maten blijven aanklikbaar (met belletje). Kiest de klant zo'n maat, dan verdwijnt de winkelmandknop
   en toont de app SW Back In Stock haar aanmeldknop, net zoals op de vorige productpagina. */
(() => {
  const init = (r) => {
    if (r.dataset.hcReady) return;
    r.dataset.hcReady = '1';
    const json = (s) => { const el = r.querySelector(s); try { return el ? JSON.parse(el.textContent) : null; } catch (_) { return null; } };
    const V = json('[data-hc-variants]') || [];
    const sel = json('[data-hc-init]') || [];
    const T = json('[data-hc-config]') || {};
    const TXT = {
      remind: T.remind || 'Herinner me',
      notify: T.notify || 'Maat [maat] is momenteel uitverkocht. Meld je aan, dan krijg je een bericht zodra hij terug op voorraad is.',
      legend: T.legend || 'Uitverkocht? Tik op de maat en krijg een bericht zodra hij terug is.',
      soldLabel: T.soldLabel || ', uitverkocht, herinner me'
    };
    const low = +T.low || 0;
    const form = r.querySelector('form');
    if (!form) return;
    const idIn = form.querySelector('input[name="id"]');
    const add = r.querySelector('[data-hc-add]');
    const msg = r.querySelector('[data-hc-msg]');
    const stock = r.querySelector('[data-hc-stock]');
    const xp = r.querySelector('[data-hc-xpay]');
    const priceEls = r.querySelectorAll('[data-hc-price]');
    const inst = r.querySelector('[data-hc-inst]');
    const groups = [...r.querySelectorAll('[data-hc-group]')];
    const sizeG = r.querySelector('[data-hc-size]');
    const sizeI = sizeG ? +sizeG.dataset.hcGroup : -1;
    const stk = r.querySelector('.hc-stk');
    const stkB = stk && stk.querySelector('.hc-stk-b');
    const stkS = stk && stk.querySelector('[data-hc-stk-size]');
    const sl = r.querySelector('.hc-slides');
    const th = [...r.querySelectorAll('.hc-thumb')];
    const cur = r.querySelector('[data-hc-cur]');

    const note = document.createElement('p');
    note.className = 'hc-notify';
    note.setAttribute('role', 'status');
    note.hidden = true;
    add.parentNode.insertBefore(note, add);

    const find = () => V.find(v => v.options.every((o, i) => sel[i] != null && o === sel[i]));
    const exists = (i, val) => V.some(v => v.options[i] === val && v.options.every((x, j) => j === i || sel[j] == null || x === sel[j]));
    const ok = (i, val) => V.some(v => v.available && v.options[i] === val && v.options.every((x, j) => j === i || sel[j] == null || x === sel[j]));
    const paint = () => groups.forEach(g => {
      const i = +g.dataset.hcGroup;
      g.querySelectorAll('.hc-pill').forEach(b => {
        const val = b.dataset.val;
        const there = exists(i, val);
        const sold = there && !ok(i, val);
        b.disabled = !there;
        b.toggleAttribute('data-soldout', sold);
        b.setAttribute('aria-pressed', String(sel[i] === val));
        b.setAttribute('aria-label', val + (sold ? TXT.soldLabel : ''));
      });
    });
    const sizeTxt = () => sizeI > -1 ? (sel[sizeI] || '') : '';

    const update = (fromUser) => {
      paint();
      const v = find();
      if (msg) msg.textContent = '';
      if (stkS) stkS.textContent = sizeTxt() ? ' · ' + sizeTxt() : '';
      note.hidden = true;
      add.hidden = false;
      if (!v) {
        if (xp) xp.hidden = true;
        add.disabled = false;
        add.textContent = T.pick;
        stock.hidden = true;
        if (stkB) stkB.textContent = T.pick;
        return;
      }
      idIn.value = v.id;
      idIn.dispatchEvent(new Event('change', { bubbles: true }));
      priceEls.forEach(e => { e.textContent = v.price; });
      if (inst && T.inst) inst.textContent = T.inst.replace('[x]', v.inst);
      if (fromUser) {
        const u = new URL(location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState(null, '', u);
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
        if (v.media && sl) {
          const k = [...sl.children].findIndex(x => +x.dataset.media === v.media);
          if (k > -1) sl.scrollTo({ left: k * sl.clientWidth });
        }
      }
      if (!v.available) {
        add.hidden = true;
        if (xp) xp.hidden = true;
        stock.hidden = true;
        note.textContent = TXT.notify.replace('[maat]', sizeTxt());
        note.hidden = false;
        if (stkB) stkB.textContent = TXT.remind;
        return;
      }
      if (xp) xp.hidden = false;
      add.disabled = false;
      add.textContent = T.cta + ' · ' + v.price;
      if (stkB) stkB.textContent = T.cta;
      const lowOn = v.tracked && low > 0 && v.stock > 0 && v.stock <= low;
      stock.hidden = !lowOn;
      if (lowOn) stock.textContent = String(T.lowMsg || '').replace('[n]', v.stock).replace('[maat]', sizeTxt());
    };

    groups.forEach(g => g.addEventListener('click', e => {
      const b = e.target.closest('.hc-pill');
      if (!b || b.disabled) return;
      sel[+g.dataset.hcGroup] = b.dataset.val;
      update(true);
    }));

    const needPick = () => {
      if (msg) msg.textContent = T.msg || '';
      (sizeG || groups[0] || form).scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    form.addEventListener('submit', e => {
      const v = find();
      if (!v) { e.preventDefault(); needPick(); return; }
      if (!v.available) { e.preventDefault(); note.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    });

    if (sl) {
      sl.addEventListener('scroll', () => {
        const i = Math.round(sl.scrollLeft / sl.clientWidth);
        if (cur) cur.textContent = i + 1;
        th.forEach((t, n) => t.setAttribute('aria-current', String(n === i)));
        r.querySelectorAll('.sb-mobile-progress-bar').forEach((b, n) => b.classList.toggle('is-active', n === i));
      }, { passive: true });
      th.forEach(t => t.addEventListener('click', () => sl.scrollTo({ left: +t.dataset.i * sl.clientWidth })));
    }

    const de = r.querySelector('[data-hc-date]');
    if (de) {
      const d = new Date();
      let n = +T.etaDays || 5;
      while (n > 0) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) n--; }
      let s;
      try { s = d.toLocaleDateString(T.loc || 'nl-BE', { weekday: 'long', day: 'numeric', month: 'long' }); }
      catch (_) { s = d.toLocaleDateString('nl-BE', { weekday: 'long', day: 'numeric', month: 'long' }); }
      de.textContent = s;
    }

    const dlg = r.querySelector('.hc-dlg');
    if (dlg && dlg.showModal) {
      r.querySelectorAll('[data-hc-chart]').forEach(b => b.addEventListener('click', () => dlg.showModal()));
      const x = dlg.querySelector('.hc-x');
      if (x) x.addEventListener('click', () => dlg.close());
      dlg.addEventListener('click', e => { if (e.target === dlg) dlg.close(); });
    }

    if (stk && stkB && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        stk.classList.toggle('on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(form);
      stkB.addEventListener('click', () => {
        const v = find();
        if (!v) { needPick(); return; }
        if (!v.available) { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        if (form.requestSubmit) form.requestSubmit(add); else add.click();
      });
    }

    update(false);

    if (sizeG && sizeG.querySelector('.hc-pill[data-soldout]')) {
      const lg = document.createElement('p');
      lg.className = 'hc-legend';
      lg.innerHTML = '<span class="hc-bell" aria-hidden="true"></span>';
      lg.appendChild(document.createTextNode(TXT.legend));
      sizeG.appendChild(lg);
    }
  };
  const run = () => document.querySelectorAll('.hc[data-hc-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();